var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-wrapper"},[_c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }